import type { CSSProperties } from 'react'

export enum SidebarOptionKind {
  dashboard = 'Dashboard',
  patient_search = 'Patient Search',
  chat = 'Chat',
  alerts = 'Alerts',
  tasks = 'Tasks',
  claims = 'Claims History',
  messages = 'Messages',
  notification = 'Notification',
  encounters = 'Open Encounters',
  recent_patients = 'Recent Patients',
  admin_page = 'Admin Page',
  separator = 'Separator',
  user = 'User',
  encounter_summary = 'Encounter Summary',
  user_info = 'User Info',
  sentry_user_feedback = 'Sentry User Feedback'
}

export interface SideBarOptionTypes {
  name: SidebarOptionKind
  id?: string
  link?: string | null
  style?: CSSProperties
  isLink?: boolean
  icon?: JSX.Element
  tooltip?: string
  isButton?: boolean
  fn?: () => void
}
